<template>
  <div>
    <MarketplaceReviewsHead
        :showFilter="showFilter"
        :selectedNow="selectedNow"
        :countFilterParams="countFilterParams"
        :userShopId="userShopId"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        @changeTab="(data) => $emit('changeTab', data)"
        @selectAll="selectAll"
        @reloadTable="$emit('reloadTable')"
        @massThermalPrint="$emit('massThermalPrint')"
    />

    <div class="table-filter-wrap">

      <MarketplaceReviewsFilter
          v-if="isAdmin"
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <MarketplaceReviewsTable
          :selectedNow="selectedNow"
          :countFilterParams="countFilterParams"
          @changeSort="data => $emit('changeSort', data)"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @downloadFiles="type => $emit('downloadFiles', type)"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import MarketplaceReviewsHead from "./MarketplaceReviewsHead/MarketplaceReviewsHead";
  import MarketplaceReviewsTable from "./MarketplaceReviewsTable/MarketplaceReviewsTable";
  import MarketplaceReviewsFilter from "./MarketplaceReviewsFilter/MarketplaceReviewsFilter";

  export default {
    name: "MarketplaceReviewsTableUser",

    components: {
      MarketplaceReviewsHead,
      MarketplaceReviewsTable,
      MarketplaceReviewsFilter,
    },

    props: {
      countFilterParams: Number,
      userShopId: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeFilter(data) {
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
